module.exports = __webpack_public_path__ + "img/vp-logo.14af11b9.png";